export default __webpack_public_path__ + "static/media/avatar_57.c58f3c22.png";